<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    stacked: {
      type: Boolean,
      default: false
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    showPercentInTooltip: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    chartData () {
      this.render()
    },
    stacked () {
      this.render()
    },
    showLegend () {
      this.render()
    },
    showPercentInTooltip () {
      this.render()
    }
  },
  mounted () {
    this.render()
  },
  methods: {
    formatNumber (value) {
      return new Intl.NumberFormat('fr-FR').format(Number(value || 0))
    },
    buildOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.showLegend
        },
        scales: {
          yAxes: [{
            stacked: this.stacked,
            ticks: {
              beginAtZero: true,
              precision: 0,
              fontSize: 10
            },
            gridLines: {
              color: '#E5E7EB'
            }
          }],
          xAxes: [{
            stacked: this.stacked,
            ticks: {
              fontSize: 10
            },
            gridLines: {
              display: false
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[tooltipItem.datasetIndex] || {}
              const value = Number(dataset.data[tooltipItem.index] || 0)
              const label = dataset.label ? `${dataset.label}: ` : ''

              if (!this.showPercentInTooltip) {
                return `${label}${this.formatNumber(value)}`
              }

              const configuredTotal = Number(data.tooltipTotal || 0)
              const total = configuredTotal > 0
                ? configuredTotal
                : (data.datasets || []).reduce((sum, item) => {
                  return sum + Number((item.data || [])[tooltipItem.index] || 0)
                }, 0)
              const percent = total > 0 ? ((value / total) * 100).toFixed(1) : '0.0'

              return `${label}${this.formatNumber(value)} (${percent} %)`
            }
          }
        }
      }
    },
    render () {
      if (!this.chartData) {
        return
      }

      this.renderChart(this.chartData, this.buildOptions())
    }
  }
}
</script>
